__turbopack_context__.v({
  "container": "ISYV6q_container",
  "field": "ISYV6q_field",
  "label": "ISYV6q_label",
  "variant--horizontal": "ISYV6q_variant--horizontal",
});
